window.__tnt = window.__tnt || {};

(function(w, d, t) {
    function _init() {
        if (!fbAppId()) return false;
        var commentsContainer = d.querySelector('#comments.fb-comments'),
          observer = new IntersectionObserver(function(el) {
            if (el[0].intersectionRatio > 0) {
                loadFacebookAPI();
                observer.unobserve(el[0].target);
            }
        }, {rootMargin: '500px'});

        observer.observe(commentsContainer);
    }

    function fbAppId() {
        var metaTags = d.getElementsByTagName('meta');
        for (var i = 0; i < metaTags.length; i++) {
            if (metaTags[i].getAttribute('property') === 'fb:app_id') {
                return metaTags[i].getAttribute('content');
            }
        }
        return false;
    }

    function loadFacebookAPI() {
        var script = d.createElement('script');
        script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.setAttribute('async', 'async');
        d.body.appendChild(script);

        w.fbAsyncInit = function() {
            FB.init({
                appId: fbAppId(),
                xfbml: true,
                version: 'v2.12'
            });

            /** comment callback */
            FB.Event.subscribe('comment.create', function(response){ 
                // Track comment event
                t.trackEvent({
                    'network': 'Facebook',
                    'socialAction': 'comment',
                    'url': w.location.href
                });
            });
        };
    }

    if (d.readyState == 'loading') {
        d.addEventListener('DOMContentLoaded', _init);
    } else {
        _init();
    }
})(window, document, __tnt);